import { render, staticRenderFns } from "./ajout.vue?vue&type=template&id=3183c0a7"
import script from "./ajout.vue?vue&type=script&lang=js"
export * from "./ajout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports